module.exports = __webpack_public_path__ + "img/44.d36eb647.png";